import React from 'react';
import PropTypes from 'prop-types';
import uniqBy from 'lodash.uniqby';
import { useSelector } from 'react-redux';
import { GiBunkBeds } from "@react-icons/all-files/gi/GiBunkBeds";
import { Button } from "day8-ui";
import { useDispatch } from 'react-redux';
import {
  getSelectedFilters, isFilterSelected, onFilterSelect, clearFilter
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';

const BoatCabins = props => {
  const dispatch = useDispatch();
  const yachts = useSelector(state => state.yachts.items);
  const boatCabinsOptions = uniqBy(yachts, 'boat.cabins')
    .map(yacht => yacht.boat.cabins)
    .sort((a, b) => a - b);
  const selectedFilters = getSelectedFilters(props.location);
  const selectedCabins = selectedFilters[FILTERS.BOAT_CABINS];
  const hasSelectedFilters = selectedCabins && selectedCabins.length > 0;
  const selectedFilterText = hasSelectedFilters ? selectedCabins.map(item => item).join(', ') : '';

  // Used to render FilterMenu list of all filters - we need this for reliably rendering 'selectedFilterText'
  return props.mobile ? (
    <div className={props.className}>
      <div>
        <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Yacht cabins</h3>
        <div className={props.inline ? 'dui-flex dui-flex-wrap dui-gap-4' : 'dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'}>
          <Button
            key="all"
            buttonType={!hasSelectedFilters ? "FILTER_ACTIVE" : "FILTER"}
            onClick={() => clearFilter(dispatch, props.filterAction, FILTERS.BOAT_CABINS)}
          >
            All
          </Button>
          {boatCabinsOptions.map(cabins => (
            <Button
              key={cabins}
              buttonType={isFilterSelected(props.location, FILTERS.BOAT_CABINS, cabins) ? "FILTER_ACTIVE" : "FILTER"}
              onClick={() => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.BOAT_CABINS, cabins)}
            >
              {cabins}
            </Button>
          ))}
        </div>
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<GiBunkBeds />}>{selectedFilterText || 'Boat cabins'}</Button>;
};
BoatCabins.propTypes = {
  location: PropTypes.object.isRequired,
  filterAction: PropTypes.func.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  inline: PropTypes.bool
};
export default BoatCabins;
